import { createFileRoute } from '@tanstack/react-router';
import { agencyUploadQuery } from '@/services/agency-upload';
import { AgencyUploadPage } from '@/features/agency-upload/agency-upload-page';

/**
 * An agency's upload link: public, no sign-in and no team. The token in the path is the only key; it never reaches
 * analytics (lib/observability and its masks name the page `/upload/:token`). The loader and the
 * page are split out of the entry, so the sign-in page's budget never pays for them; a refusal is the page's to show.
 * The loader starts the read and never waits for it: the page reads it too, so a slow first load shows the page's own
 * loading card on the studio field, never the app's Draper splash.
 */
export const Route = createFileRoute('/upload/$token')({
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.prefetchQuery(agencyUploadQuery(params.token));
  },
  component: UploadRoute,
});

function UploadRoute() {
  const { token } = Route.useParams();
  return <AgencyUploadPage token={token} />;
}
